import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import GradientButton from "@/components/buttons/GradientButton.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'GradientIconButton',
  props: {
    btnClasses: {},
    iconClasses: {},
    iconSrc: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GradientButton, {
    class: _normalizeClass(["rounded-xl shrink-0", __props.btnClasses]),
    "bg-color": "bg-brown-gradient",
    "hover-bg-color": "bg-orange-gradient",
    text: "",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    icon: _withCtx(() => [
      _createElementVNode("img", {
        src: __props.iconSrc,
        alt: "Print",
        class: _normalizeClass(["z-10", __props.iconClasses])
      }, null, 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})